import * as React from 'react'

import { AccessibleVideo, } from '../../../../../Shared/index'
import { ADMIN_ANIMATION_VIDEO } from './asset_constants'
import SelectedTourIntroSlide from './shared_slides/selected_tour_intro_slide'
import FinalSlide from './shared_slides/final_slide'
import LearningToWriteSlide from './shared_slides/learning_to_write_slide'
import ActivitySummarySlide from './shared_slides/activity_summary_slide'
import GrowthDiagnosticSlide from './shared_slides/growth_diagnostic_slide'
import BeginWithADiagnosticSlide from './shared_slides/begin_with_a_diagnostic_slide'
import ChooseTheProficiencyLevelSlide from './shared_slides/choose_the_proficiency_level_slide'
import PersonalizedActivitySequencesSlide from './shared_slides/personalized_activity_sequences_slide'
import RecommendedPacksSlide from './shared_slides/recommended_packs_slide'
import OurAimSlide from './shared_slides/our_aim_slide'


const slideGroupClassName = 'elementary-and-middle-school-ela-slide'

const selectedTourIntroSlide = (
  <SelectedTourIntroSlide slideGroupClassName={slideGroupClassName} />
)

const learningToWriteSlide = (
  <LearningToWriteSlide slideGroupClassName={slideGroupClassName} />
)

const beginWithADiagnosticSlide = (
  <BeginWithADiagnosticSlide
    paragraphs={
      <React.Fragment>
        <p>Quill diagnostics assess over <b>40 writing skills</b> spanning Starter through Advanced and AP® levels. </p>
        <p>With <b>pre- and post-tests</b>, you can easily measure student growth over time. </p>
        <p>Diagnostics support English learners by offering directions <b>translated into 16 languages</b>, and automatically generate <b>personalized learning plans</b> tailored to each student’s performance.</p>
      </React.Fragment>
    }
    slideGroupClassName={slideGroupClassName}
  />
)

const chooseTheProficiencyLevelSlide = (
  <ChooseTheProficiencyLevelSlide
    ell={false}
    slideGroupClassName={slideGroupClassName}
  />
)

const personalizedActivitySequencesSlide = (
  <PersonalizedActivitySequencesSlide slideGroupClassName={slideGroupClassName} />
)

const recommendedPacksSlide = (
  <RecommendedPacksSlide
    slideGroupClassName={slideGroupClassName}
    video={
      <AccessibleVideo
        ariaLabel="Animation of a user completing a sentence combining activity"
        src={ADMIN_ANIMATION_VIDEO}
      />
    }
  />
)

const activitySummarySlide = (
  <ActivitySummarySlide slideGroupClassName={slideGroupClassName} />
)

const growthDiagnosticSlide = (
  <GrowthDiagnosticSlide slideGroupClassName={slideGroupClassName} />
)

const ourAimSlide = (
  <OurAimSlide slideGroupClassName={slideGroupClassName} />
)

const elementaryAndMiddleSchoolELASlides = ({ getPremiumCredit, }) => [
  selectedTourIntroSlide,
  learningToWriteSlide,
  beginWithADiagnosticSlide,
  chooseTheProficiencyLevelSlide,
  personalizedActivitySequencesSlide,
  recommendedPacksSlide,
  activitySummarySlide,
  growthDiagnosticSlide,
  ourAimSlide,
  <FinalSlide getPremiumCredit={getPremiumCredit} key="final-slide" />,
]

export default elementaryAndMiddleSchoolELASlides
